function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState, useMemo } from "react";
import classnames from "classnames";
import { BUCKET_OPTIONS, UNIT_OF_MEASURE } from "segments/desktop/pricing/constants";
import productPricingConfig from "segments/desktop/pricing/product-pricing-config";
import CarouselGallary from "/components/core/carousel-gallary/carousel-gallary";
import { trackEvent } from "services/bigbrain-service";
import { PRICING_PAGE_PURCHASE_NOW_CLICKED, PRICING_PAGE_SEAT_BUCKET_CHANGED, PRICING_PAGE_PERIOD_CHANGED, PRICING_PAGE_BUCKET_AMOUNT_CHANGED } from "constants/bigbrain-event-types";
import { storeNumberOfContacts, storeNumberOfSeats } from "services/sales-enrichment/sales-enrichment-service";
import { TIERS } from "constants/pricing";
import { getPreviousTierNameByTier } from "services/pricing/plans-service";
import ProductPriceAndFeaturesCard from "./product-price-and-features-card/product-price-and-features-card";
import { UsersSelect } from "./users-select/users-select-component";
import { PeriodSelect } from "./period-select/period-select-component";
import PurchaseNowModal from "../components/purchase-now-modal/purchase-now-modal";
import { getMostPopularTierAndText } from "/services/pricing/pricing-page/most-popular-service";
import { StyledProductPriceAndFeaturesCards } from "./product-prices-and-features-cards-component.scss";
const ProductPriceAndFeaturesCards = ({ productName, isTypeformDisabled, hideFreeTier, hideFreeForever, translateOrTranslateWithParam, isHomepagePricing, cookies, forcePricing, abTests, hasFreeTier, isApplyMaxDiffFeatures, defaultSeatsIndex, pricesAndFeaturesCardsPricing, isNewPricing, shouldHideBasicTier, unitOfMeasure })=>{
    const { tiers, color, colorMobile, ctaHoverBackgroundColor, ctaHoverBorderColor, ctaHoverTextColor, hideProductIcon, primaryColor, secondaryColor, productId, showLearnMoreVideo, showFreeTierComingSoon, labeledTierFeatures } = productPricingConfig[productName];
    const { color: coreColor } = productPricingConfig.core;
    const SeatsOptionsIndex = defaultSeatsIndex ? defaultSeatsIndex : 0;
    const optionsIndex = unitOfMeasure === UNIT_OF_MEASURE.CONTACTS ? 0 : SeatsOptionsIndex;
    const options = BUCKET_OPTIONS[unitOfMeasure] || BUCKET_OPTIONS[UNIT_OF_MEASURE.SEATS];
    const [bucketAmount, setBucketAmount] = useState(Object.values(options)[optionsIndex]);
    const [period, setPeriod] = useState("yearly");
    const [purchaseNowModal, setPurchaseNowModal] = useState(false);
    const [purchaseModalTarget, setPurchaseModalTarget] = useState(null);
    const onPurchaseNowClicked = ({ tier, target })=>{
        trackEvent(PRICING_PAGE_PURCHASE_NOW_CLICKED, {
            kind: productName,
            info1: tier.name,
            info2: period,
            info3: bucketAmount,
            productKind: productName
        });
        setPurchaseNowModal(true);
        setPurchaseModalTarget(target);
    };
    const setSelectedBucketAmount = useCallback((newSelectedBucketAmount)=>{
        if (unitOfMeasure === UNIT_OF_MEASURE.CONTACTS) {
            storeNumberOfContacts(newSelectedBucketAmount);
            trackEvent(PRICING_PAGE_BUCKET_AMOUNT_CHANGED, {
                info1: newSelectedBucketAmount,
                info2: bucketAmount,
                productKind: productName
            });
        } else {
            storeNumberOfSeats(newSelectedBucketAmount);
            trackEvent(PRICING_PAGE_SEAT_BUCKET_CHANGED, {
                info1: newSelectedBucketAmount,
                info2: bucketAmount,
                productKind: productName
            });
        }
        setBucketAmount(newSelectedBucketAmount);
    }, [
        productName,
        bucketAmount,
        unitOfMeasure
    ]);
    const setSelectedPeriod = useCallback((newSelectedPeriod)=>{
        trackEvent(PRICING_PAGE_PERIOD_CHANGED, {
            info1: newSelectedPeriod,
            info2: period,
            productKind: productName
        });
        setPeriod(newSelectedPeriod);
    }, [
        period,
        productName
    ]);
    const getTiers = useCallback(()=>{
        // hasFreeTier is cookie monday_has_free_tier based
        // hideFreeTier is a prop passed from the generator
        // free tier will be hidden if hasFreeTier is false OR if hasFreeTier AND hideFreeTier are true
        // TODO: extract to util function or custom hook
        if (!hasFreeTier || hideFreeTier) {
            return tiers.filter((tier)=>tier.name !== TIERS.FREE);
        }
        return tiers;
    }, [
        tiers,
        hideFreeTier,
        hasFreeTier
    ]);
    const getConditionalFeatures = useCallback((tier)=>{
        // If this is the STANDARD tier and shouldHideBasicTier is true, use alternative features
        if (tier.name === TIERS.STANDARD && shouldHideBasicTier) {
            return [
                "unlimitedItems",
                "unlimitedBoards",
                "guestAccess",
                "automations250",
                "integrations250",
                "over20ColumnTypes",
                "dashboardCombined5boards",
                "timelineAndGanttViews"
            ];
        }
        // Otherwise return the tier's original features
        return tier.features;
    }, [
        shouldHideBasicTier
    ]);
    const getPreviousTierName = (tier)=>{
        return getPreviousTierNameByTier(tier, filteredTiers);
    };
    const mostPopularTier = useMemo(()=>{
        const relevantTiers = getTiers();
        if (!relevantTiers) return;
        const modifiedTiers = relevantTiers.map((tier)=>_object_spread_props(_object_spread({}, tier), {
                tier: tier.name
            }));
        const { tier: mostPopularTierName } = getMostPopularTierAndText(bucketAmount, modifiedTiers, null, abTests, cookies, forcePricing, unitOfMeasure);
        return mostPopularTierName;
    }, [
        abTests,
        cookies,
        forcePricing,
        bucketAmount,
        tiers
    ]);
    const filteredTiers = shouldHideBasicTier ? getTiers().filter((tier)=>tier.name !== TIERS.BASIC) : getTiers();
    return /*#__PURE__*/ _jsxs(StyledProductPriceAndFeaturesCards, {
        numberOfTiers: filteredTiers.length,
        className: classnames("container", {
            "is-homepage-pricing": isHomepagePricing
        }),
        isNewPricing: isNewPricing,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "seats-and-period-selection",
                children: [
                    /*#__PURE__*/ _jsx(UsersSelect, {
                        usersCountArray: options,
                        updateSelectedUserCountCallback: setSelectedBucketAmount,
                        productName: productName,
                        defaultSeatsIndex: optionsIndex,
                        unitOfMeasure: unitOfMeasure
                    }),
                    /*#__PURE__*/ _jsx(PeriodSelect, {
                        color: color,
                        isHomepagePricing: isHomepagePricing,
                        primaryColor: primaryColor,
                        period: period,
                        onPeriodChange: setSelectedPeriod
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "tiers",
                children: filteredTiers.map((tier)=>{
                    const tierWithConditionalFeatures = _object_spread_props(_object_spread({}, tier), {
                        features: getConditionalFeatures(tier)
                    });
                    return /*#__PURE__*/ _jsx(ProductPriceAndFeaturesCard, {
                        period: period,
                        hideProductIcon: hideProductIcon,
                        productName: productName,
                        tier: tierWithConditionalFeatures,
                        tiers: getTiers(),
                        previousTierName: getPreviousTierName(tier),
                        color: color,
                        colorMobile: colorMobile,
                        ctaHoverBackgroundColor: ctaHoverBackgroundColor,
                        ctaHoverBorderColor: ctaHoverBorderColor,
                        ctaHoverTextColor: ctaHoverTextColor,
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        seats: bucketAmount,
                        coreColor: coreColor,
                        isMostPopular: isNewPricing && mostPopularTier !== TIERS.ENTERPRISE ? tier.name === TIERS.PRO : mostPopularTier === tier.name,
                        onPurchaseNowClicked: onPurchaseNowClicked,
                        hideFreeForever: hideFreeForever,
                        isHomepagePricing: isHomepagePricing,
                        productId: productId,
                        showLearnMoreVideo: showLearnMoreVideo,
                        showFreeTierComingSoon: showFreeTierComingSoon,
                        isApplyMaxDiffFeatures: isApplyMaxDiffFeatures,
                        labeledTierFeatures: labeledTierFeatures,
                        getQuoteModalFullParagraph: pricesAndFeaturesCardsPricing === null || pricesAndFeaturesCardsPricing === void 0 ? void 0 : pricesAndFeaturesCardsPricing.getQuoteModalFullParagraph,
                        hubspotFromFieldValue: pricesAndFeaturesCardsPricing === null || pricesAndFeaturesCardsPricing === void 0 ? void 0 : pricesAndFeaturesCardsPricing.hubspotFromFieldValue,
                        isNewPricing: isNewPricing,
                        unitOfMeasure: unitOfMeasure
                    });
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "tiers tiers-mobile",
                children: /*#__PURE__*/ _jsx(CarouselGallary, {
                    className: "carousel-item",
                    autoplay: false,
                    wrapAround: false,
                    edgeEasing: "easeBack",
                    slidesToShow: 1,
                    slideIndex: 1,
                    cellAlign: "center",
                    cellSpacing: 16,
                    width: "100vw",
                    slideWidth: 0.7,
                    renderCenterLeftControls: ()=>{},
                    renderCenterRightControls: ()=>{},
                    heightMode: "max",
                    children: getTiers().map((tier)=>{
                        const tierWithConditionalFeatures = _object_spread_props(_object_spread({}, tier), {
                            features: getConditionalFeatures(tier)
                        });
                        return /*#__PURE__*/ _jsx(ProductPriceAndFeaturesCard, {
                            period: period,
                            isTypeformDisabled: isTypeformDisabled,
                            hideProductIcon: hideProductIcon,
                            productName: productName,
                            tier: tierWithConditionalFeatures,
                            color: color,
                            colorMobile: colorMobile,
                            ctaHoverBackgroundColor: ctaHoverBackgroundColor,
                            ctaHoverBorderColor: ctaHoverBorderColor,
                            ctaHoverTextColor: ctaHoverTextColor,
                            seats: bucketAmount,
                            coreColor: coreColor,
                            isMostPopular: isNewPricing && mostPopularTier !== TIERS.ENTERPRISE ? tier.name === TIERS.PRO : mostPopularTier === tier.name,
                            onPurchaseNowClicked: onPurchaseNowClicked,
                            translateOrTranslateWithParam: translateOrTranslateWithParam,
                            labeledTierFeatures: labeledTierFeatures,
                            unitOfMeasure: unitOfMeasure
                        });
                    })
                })
            }),
            /*#__PURE__*/ _jsx(PurchaseNowModal, {
                isOpen: purchaseNowModal,
                signupButton: purchaseModalTarget
            })
        ]
    });
};
export default ProductPriceAndFeaturesCards;
